import {InjectionToken} from "@angular/core";
import type {ILogService} from "angular";

/** Definerer metoder fra ajs {@link ILogService} som vi benytter i ng2-koden */
export interface AjsLogService extends Pick<ILogService, 'error'>{
}

export const ajs_$log_DI_TOKEN = new InjectionToken<AjsLogService>('ajs $log');
